export const blockIconsNavigationExpandLess = (
	<span className='material-symbols-outlined'>expand_less</span>
);
